import { render, staticRenderFns } from "./_wbet.vue?vue&type=template&id=32eddebe&scoped=true&lang=pug&"
import script from "./_wbet.vue?vue&type=script&lang=js&"
export * from "./_wbet.vue?vue&type=script&lang=js&"
import style0 from "./_wbet.vue?vue&type=style&index=0&id=32eddebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eddebe",
  null
  
)

export default component.exports